import classnames from 'classnames'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import * as Bridge from '@/api/BridgeApi'
import { STATUS_BAR_COLOR } from '@/domains/CommonDomain'
import { STATUS_CODE } from '@/domains/CommonDomain'
import { useLoadingTimeout } from '@/hooks/useLoadingTimeout'
// import { useTimeout } from '@/hooks/useTimeout'
import { useTrans } from '@/hooks/useTrans'
import { errorActions } from '@/modules/common/error'
import { newError } from '@/utils/errorUtils'

interface ILoadingProps {
  isDimmed?: boolean
  isSchedulePaymentRegister?: boolean
}

export const Loading = (props: ILoadingProps) => {
  const $ = useTrans()
  const dispatch = useDispatch()
  const { isDimmed = false, isSchedulePaymentRegister = false } = props
  const loaderClassNames = classnames('loader', {
    'loader--dimmed': isDimmed,
  })
  // const [isOver] = useTimeout()
  const [isOver] = useLoadingTimeout()

  useEffect(() => {
    if (isDimmed && isSchedulePaymentRegister) {
      Bridge.changeStatusBar({
        backgroundColor: STATUS_BAR_COLOR.SCHEDULE_PAYMENT_REGISTER_LOADING,
      })
    } else {
      Bridge.changeStatusBar({ backgroundColor: STATUS_BAR_COLOR.DEFAULT })
    }

    if (isOver) {
      const time = 3 * 60 * 1000
      const timerId = setTimeout(() => {
        dispatch(errorActions.set(newError(STATUS_CODE.LOADING_FAILED)))
      }, time)

      return () => {
        clearTimeout(timerId)
      }
    }

    return () => {
      Bridge.changeStatusBar({ backgroundColor: STATUS_BAR_COLOR.DEFAULT })
    }
  }, [dispatch, isDimmed, isOver, isSchedulePaymentRegister])

  const LoadingText = () => {
    if (!isOver) {
      return <></>
    }

    return <p className="loader__dsc">{$('general_loading_timeover_desc')}</p>
  }

  return (
    <div className={loaderClassNames}>
      <div className="loader__item">
        <svg
          className="loader__spinner"
          width="52px"
          height="52px"
          viewBox="0 0 58 58"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="loader__bg"
            fill="none"
            strokeWidth="6"
            cx="29"
            cy="29"
            r="26"
          ></circle>
          <circle
            className="loader__path"
            fill="none"
            strokeWidth="6"
            strokeLinecap="round"
            cx="29"
            cy="29"
            r="26"
          ></circle>
        </svg>
      </div>
      <LoadingText />
    </div>
  )
}
